<template>
  <vbt-content-box
    :loading="isLoading"
    :loading-error="loadingError"
    :no-content="noContent"
    :go-back-btn="goBack"
    title="History"
  >
    <vbt-table
      :items="tenantHistory"
      :headers="headers"
    >
      <template #processed="{ item: { processed } }">
        {{ formatDisplayDate(processed) }}
      </template>
    </vbt-table>

    <vbt-pagination
      v-model="pageNum"
      :items-count="pagedItemsCount"
    />
  </vbt-content-box>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import { useDataLoading, usePagination } from '@mixins/factories';

import { formatDisplayDate } from '@helpers';

import { namespace as TenantsNamespace, ActionTypes as TenantsActionTypes } from '../store.types';

const dataLoadingOptions = {
  getterName: TenantsActionTypes.GET_TENANT_HISTORY,
  contentName: 'tenantHistory',
  parameterize: true,
  searchable: false,
};
const paginationOptions = { contentName: 'tenantHistory' };

const headers = Object.freeze([
  { text: 'Action', value: 'action' },
  { text: 'Description', value: 'description' },
  { text: 'User', value: 'user' },
  { text: 'Processed Date', value: 'processed' },
]);

export default {
  name: 'UmsTenantHistory',
  mixins: [
    useDataLoading(dataLoadingOptions),
    usePagination(paginationOptions),
  ],
  data: () => ({ headers }),
  computed: {
    ...mapState(TenantsNamespace, ['tenantHistory']),
  },
  methods: {
    ...mapActions(TenantsNamespace, [TenantsActionTypes.GET_TENANT_HISTORY]),
    formatDisplayDate,
  },
};
</script>
